const preventDrinksModalOnBlogPage = () => {
    if (window.location.pathname.includes("/blogs/")) {
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.addedNodes.length) {
                    var modal = document.querySelector(".drinks-age-modal-container");
                    if (modal) {
                        modal.style.display = "none";
                        observer.disconnect();
                    }
                }
            });
        });

        observer.observe(document, { childList: true, subtree: true });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    preventDrinksModalOnBlogPage();
});